import { slice } from './slice';

// Action creators are generated for each case reducer function.
// export const {
// 	fetchCustomerByEmail
// } =	slice.actions;

// Selectors returned by `slice.selectors` take the root state as their first argument.
export const {
	customerState,
	selectCustomerName,
	selectCustomerEmail
} = slice.selectors;

export { loadCustomer } from './slice';
export type { State as CustomerState } from './state.type';
